export * from './same-width-text.component';
